import { Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'lex-operations-production-download-dialog',
    templateUrl: './operations-production-download-dialog.component.html',
    styleUrls: ['./operations-production-download-dialog.component.scss'],
    standalone: false
})
export class OperationsProductionDownloadDialogComponent {

  exportPattern = `\\\\\\\\(([aA][uU][sS][tT][iI][nN])|([aA][mM][aA][zZ][oO][nN]))\\\\[a-zA-Z0-9_\\-\\\\\\s]*`;
  amazonServerURI = '\\\\amazon\\';
  austinServerURI = '\\\\austin\\';
  downloadProductionAmazonFunctionId: string = '8343ef15-b7a0-4716-8362-eed90138c939';
  downloadProductionAustinFunctionId: string = '171ef9c9-8212-e811-a988-121a0f91a96a';
  productionDownloadPath: UntypedFormControl = new UntypedFormControl(['']);

  constructor(private dialogRef: MatDialogRef<OperationsProductionDownloadDialogComponent>) { }

  download() {
    let functionId: string = null;
    let downloadPath: string = null;
    const tempFolderPath: string = this.productionDownloadPath.value.trimEnd('\\');
    if (tempFolderPath.toLowerCase().includes(this.amazonServerURI)) {
      functionId = this.downloadProductionAmazonFunctionId;
      downloadPath = this.formatPathString(tempFolderPath, this.amazonServerURI);
    } else if (tempFolderPath.toLowerCase().includes(this.austinServerURI)) {
      functionId = this.downloadProductionAustinFunctionId;
      downloadPath = this.formatPathString(tempFolderPath, this.austinServerURI);
    }

    this.dialogRef.close({ functionId: functionId, downloadPath: downloadPath });
  }

  formatPathString(path: string, uri: string): string {
    const tempFolderPath = path.toLowerCase().replace(uri, '');
    return [tempFolderPath.slice(0, 1), ':', tempFolderPath.slice(1, tempFolderPath.length)].join('');
  }
}
